import * as ACT from '../actions/actions';

const orderReducer = (state = [], action) => {
    switch (action.type) {
        case ACT.ADD_ORDER:
            for (let order of state)
                if (order.name === action.order.name)
                    return state;

            return [...state, action.order];

        case ACT.UPDATE_ORDER:
            for (let i = 0, order; i < state.length; i++) {
                order = state[i];

                if (order.name === action.order.name) {

                    if (typeof action.order.details !== 'undefined')
                        order.details = Object.assign({}, order.details, action.order.details);

                    if (typeof action.order.deadline !== 'undefined')
                        order.deadline = action.order.deadline;

                    if (typeof action.order.files !== 'undefined')
                        order.files = action.order.files;

                    state[i] = order;
                    break;
                }
            }
            return state;

        case ACT.REMOVE_ORDER:
            return state.filter(order => order.name !== action.name);

        default:
            return state;
    }
};

export default orderReducer;


// WEBPACK FOOTER //
// ./src/app/reducers/ordersReducer.js